export default {
	props: {
		width: {
			type: Number,
			default: undefined
		}
	},
	data() {
		return {
			popperMinWidth: 'auto',
			menuOnTop: false
		};
	},
	mounted() {
		if (this.toggleList instanceof Function) {
			this.toggleMenu = this.toggleList;
		}
	},
	updated() {
		this.updateWidth();
	},
	methods: {
		updateWidth() {
			if (this.width && this.$refs.dropdownListRef) {
				this.$refs.dropdownListRef.$el.style.minWidth = `${this.width}px`;
			} else if (this.$refs.dropdownListRef) {
				const dropdownShape = this.$refs.dropdownPosRef;

				if (!dropdownShape) {
					return;
				}
				const dropdownShapeWidth = dropdownShape.getBoundingClientRect()
					.width;
				this.$refs.dropdownListRef.$el.style.minWidth = `${dropdownShapeWidth}px`;
			}
		},
		setpopperMinWidth(value) {
			this.popperMinWidth = value;
		},
		updateIconOrientation(e) {
			this.menuOnTop = e.includes('top') ? true : false;
		}
	}
};
